export default __webpack_public_path__ + "static/media/smBannerDaCrazyDarkMode.fc9dda80.png";